export default {
  
  personal_projects: [
    {
      image: '/home-panels/spaceball.jpeg',
      title: 'Spaceball.fr',
      link: 'https://spaceball.fr',
      icon: '/icons/gamepad-modern.svg',
      description: 'A mix of bumper cars and soccer, like a 2D Rocket League, which is played on a computer screen with your phones as controllers.',
      buttonText: 'Play the game',
      subItem: true
    },
    {
      image: '/home-panels/idle_please.jpeg',
      title: 'Idle Please',
      path: 'idle_please',
      icon: '/icons/gamepad-modern.svg',
      description: 'Once upon a time, there was a developer who was bored and played too many idle games. Thus, he gave birth to this absurd game, which is trying very hard to waste your time.',
      buttonText: 'Play the game',
      imagePosition: 'center top',
      subItem: true
    },
    {
      image: '/home-panels/parsigooyan.jpeg',
      title: 'Persian Dictionnary',
      link: 'https://parsigooyan.org',
      icon: '/icons/book.svg',
      description: 'A dictionnary of foreign words in Farsi. This is my grandmother\'s project. It was a book, now it\'s online',
      buttonText: 'Try the dictionnary',
      imagePosition: 'center top',
      subItem: true
    },
    {
      image: '/home-panels/2_min_du_peuple.jpeg',
      title: '2min Du Peuple',
      link: 'https://jesuisuncaillou.github.io/deuxminutesdupeuple/',
      icon: '/icons/laugh.svg',
      description: 'Listen to 500+ episodes of "Les deux minutes du peuple" as much as you want, with the best audio player I could make.',
      buttonText: 'Listen now',
      imagePosition: 'center bottom',
      subItem: true
    },
    {
      image: '/home-panels/qr_code_generator.jpeg',
      title: 'QR code Generator',
      path: '/qrcode',
      icon: '/icons/qrcode.svg',
      description: 'A very simple QR code generator. No data tracking, no ads. Nothing else.',
      buttonText: 'Make a QR code',
      imagePosition: 'center top',
      subItem: true
    },
    {
      image: '/home-panels/podcast.jpeg',
      title: 'Podcast',
      link: 'https://www.youtube.com/channel/UCcuNRC4A4S-wYU3ExLc8rnw',
      icon: '/icons/microphone-alt-solid.svg',
      description: 'Interviews with former students at ENSIIE, for the current students. Talks about professionnal life after the school and stuff, in French.',
      buttonText: 'Listen now',
      subItem: true,
      separation: true

    },
    // {
    //   image: '/home-panels/overwatch-tips.jpeg',
    //   title: 'Overwatch Tips',
    //   link: 'http://overwatch-tips.herokuapp.com',
    //   icon: '/icons/overwatch-logo.svg',
    //   description: 'A website we built with a friend at the dawn of the Overwatch game. It worked well for a while, now I just keep it alive as a souvenir.',
    //   buttonText: 'Check it out',
    // },
  ],
  
  comedian: [
    {
      image: '/caillou_sur_scene.webp',
      title: 'Caillou on stage',
      path: 'sur_scene',
      icon: '/icons/calendar.svg',
      description: 'I keep this page updated with all my next shows, if you want to see me perform. Mostly in french, but sometimes in english too.',
      buttonText: 'Upcoming dates',
      subItem: true

    },
    {
      image: '/home-panels/bar.jpeg',
      title: 'Comedy Clubs',
      path: '/comedy_clubs',
      icon: '/icons/map_marker.svg',
      description: 'A list of Parisian comedy clubs, for comedians looking for a place to try their jokes. If you want to start, check it out !',
      buttonText: 'See the list',
      subItem: true
    },
  ],
  author: [
    {
      image: '/home-panels/caillou_haaa.jpeg',
      title: 'Webcomic',
      path: '/webcomic',
      icon: '/icons/comments-regular.svg',
      description: 'An absurd webcomic about talking rocks. Written in french, but the 18 first pages have been translated into English.',
      buttonText: 'Read the webcomic',
      subItem: true
    },
    {
      image: '/home-panels/d20.jpeg',
      title: 'DnD Game Master',
      link: 'https://disboard.org/fr/server/978987369065750579',
      icon: '/icons/dice-d20.svg',
      description: 'I manage a french DnD discord server with an ongoing story played by dozens of players. My team of game masters and I are sheduling an average of one game per week for our players.',
      buttonText: 'Join the discord',
      subItem: true
    },

  ]
}